import { Box, Button, Card, CardContent, Typography, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { useState, useEffect } from 'react'
import { DataGrid } from '@mui/x-data-grid'
// ICON
import EditIcon from '@mui/icons-material/Edit'
import PrintIcon from '@mui/icons-material/Print'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import SearchIcon from '@mui/icons-material/Search';
import PaidIcon from '@mui/icons-material/Paid';
import InfoIcon from '@mui/icons-material/Info';
//
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom'
import moment from 'moment'
import 'moment/locale/th'
import { createTheme, ThemeProvider } from '@mui/material/styles';
// Custom Component
import LandRegistrationInfoModal from './ChildComponent/LandRegistrationInfoModal'
// Custom Hooks
import useLandregistration from './hooks/useLandregistration'
import useVerifyToken from '../../hooks/useVerifyToken'
import useAuth from '../../hooks/useAuth'

const cardBodyStyle = {
    border: ' grey',
    background: '#fafaeb',
    textAlign: 'center',
    m: 2,
    width: '90%',
    justifyContent: 'center',
    // borderRadius: 2,
}
const cardStyle = {
    m: 2,
    width: '90%',
    justifyContent: 'center',
    borderRadius: 2
}

export default function LandRegisration() {
    const { verifyToken } = useVerifyToken()
    const navigate = useNavigate()
    const location = useLocation()
    const { user } = useAuth()

    // SearchParams
    let [searchParams, setSearchParams] = useSearchParams()
    const [search, setSearch] = useState({
        parcelCode: searchParams.get('parcelCode') || '',
        oldParcel: searchParams.get('oldParcel') || '',
        dn: searchParams.get('dn') || '',
        houseName: searchParams.get('houseName') || ''
    })
    const [rowData, setRowData] = useState()
    const [registrationData, setRegistrationData] = useState([])
    const [rowId, setRowId] = useState()
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)
    const [statusChangedNote, setStatusChangedNote] = useState('')
    const [addModalOpen, setAddModalOpen] = useState(false)
    const [editModalOpen, setEditModalOpen] = useState(false)
    const [infoModalOpen, setInfoModalOpen] = useState(false)
    // Alert Popup
    const [successAlertOpen, setSuccessAlertOpen] = useState(false)
    const [errorAlertOpen, setErrorAlertOpen] = useState(false)
    const [successText, setSuccessText] = useState('')
    const [errorText, setErrorText] = useState('')
    const handleDeleteDialogClickOpen = () => {
        setDeleteDialogOpen(true);
    };
    // Custom Hooks
    const { fetchRegistrationData, fetchChangeLog } = useLandregistration()
    //

    const handleDeleteDialogClose = () => {
        setDeleteDialogOpen(false)
        setStatusChangedNote('')
        setRowId(undefined)
    };
    const columns = [
        { field: 'id', headerName: 'Gid', width: 60 },
        { field: 'parcel_cod', headerName: 'รหัสแปลงที่ดิน', width: 120 },
        { field: 'old_parcel', headerName: 'รหัสแปลงที่ดินเก่า', width: 120 },
        {
            field: 'rawang', headerName: 'ระวาง', width: 120,
            renderCell: (params) => {
                return params.row.utmmap1 + '-' + parseInt(params.row.utmmap2) + '-' + params.row.utmmap3 + '-' + params.row.utmmap4
            }
        },
        {
            field: 'dn', headerName: 'เลขเอกสารสิทธิ์', width: 120,
            renderCell: (params) => {
                return parseInt(params.row.dn) || ''
            }
        },
        {
            field: 'land_no', headerName: 'เลขที่ดิน', width: 120,
            renderCell: (params) => {
                return parseInt(params.row.land_no) || ''
            }
        },
        {
            field: 'survey_no', headerName: 'หน้าสำรวจ', width: 120,
            renderCell: (params) => {
                return parseInt(params.row.survey_no) || ''
            }
        },
        { field: 'land_area', headerName: 'เนื้อที่', width: 120 },
        {
            field: 'Button',
            headerName: '',
            sortable: false,
            width: 350,
            renderCell: (params) => {
                return (
                    <Box>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<InfoIcon />}
                            onClick={() => {
                                setRowData(params.row)
                                setInfoModalOpen(true)
                            }}
                        >
                            ดูข้อมูล
                        </Button>
                    </Box >
                )
            }
        }
    ]
    useEffect(() => {
        fetchChangeLog()
    }, [])

    useEffect(() => {
        fetchRegistrationData(setRegistrationData)
        // eslint-disable-next-line
    }, [])
    // useEffect(() => {
    //     console.log(registrationData)
    // }, [registrationData])


    return (
        <Box className='otherSide' id="otherSide">
            <Box className='surveyLayouts' id="surveyLayouts">
                <Card sx={cardBodyStyle}>
                    <CardContent >
                        <Typography variant='h5'>ทะเบียนคุมแปลงที่ดิน</Typography>
                    </CardContent>
                    <CardContent>
                        <Box
                            component="form"
                            sx={{
                                '& .MuiTextField-root': { m: 1, width: '25ch' },
                                '& button': { m: 1, mt: 2, width: '15ch' }
                            }}
                            noValidate
                            autoComplete="off"
                            onSubmit={(event) => {
                                event.preventDefault()
                                setSearchParams({ parcelCode: search.parcelCode })
                                //ถ้าไม่มีข้อมูลค้นหา ให้เคลียร์paramแล้วดึงข้อมูลข้อมูลเริ่มต้น
                                if (search.parcelCode === '' && search.address === '' && search.houseName === '') {
                                    setSearchParams()
                                    // axiosWasteFeeDataList(setWasteFeeDataList)
                                }
                                fetchRegistrationData(setRegistrationData, search.parcelCode, search.oldParcel, search.dn)
                            }}
                        >
                            <Box sx={{ textAlign: 'center' }}>
                                <TextField
                                    id="parcelCode"
                                    label="รหัสแปลงที่ดิน"
                                    onChange={(event) => setSearch({ ...search, parcelCode: event.target.value.toLocaleUpperCase() })}
                                    value={search.parcelCode}
                                />
                                <TextField
                                    id="oldParcel"
                                    label="รหัสแปลงที่ดินเก่า"
                                    onChange={(event) => setSearch({ ...search, oldParcel: event.target.value.toLocaleUpperCase() })}
                                    value={search.oldParcel}
                                />
                                <TextField
                                    id="dn"
                                    label="เลขที่โฉนด"
                                    onChange={(event) => setSearch({ ...search, dn: event.target.value })}
                                    value={search.dn}
                                />
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    type='submit'
                                    startIcon={<SearchIcon />}
                                >
                                    ค้นหา
                                </Button>
                            </Box>
                            <div style={{
                                justifyContent: 'center',
                                display: "flex"
                            }}>

                            </div>
                        </Box>
                    </CardContent>
                    <CardContent>
                        <Box style={{ height: 635, width: 'auto' }}>
                            <DataGrid
                                rows={registrationData}
                                columns={columns}
                                pageSize={10}
                                rowsPerPageOptions={[10]}
                            />
                        </Box>
                    </CardContent>
                </Card>
                <LandRegistrationInfoModal
                    infoModalOpen={infoModalOpen}
                    setInfoModalOpen={setInfoModalOpen}
                    rowData={rowData}
                />
            </Box>
        </Box>
    )
}
